module.exports = __webpack_public_path__ + "img/duck0.930fb517.png";